import React, { Component } from "react";
import { Button, Navbar, Nav, NavDropdown, Form } from "react-bootstrap";
import $ from "jquery";
import { logout } from "../services/auth";
import { URL } from "../constants/index";

class NavBI extends Component {
  constructor(props) {
    super(props);

    this.onDashboardMensal = this.onDashboardMensal.bind(this);
    this.onDashboardAtual = this.onDashboardAtual.bind(this);
    this.onLogout = this.onLogout.bind(this);
  }

  getMenuDashboard = (linkMenu) => {
    if (!linkMenu) {
      return;
    }

    var report = this.props.report;
    console.log(report);
    report
      .setPage(linkMenu)
      .then(function () {})
      .catch(function (errors) {});
  };

  onLogout() {
    logout()
      .then((res) => this.props.history.push(URL.URLLogin))
      .catch((res) => this.props.history.push(URL.URLLogin));
  }

  onDashboardMensal() {
    this.props.history.push(URL.URLDashboardMensal);
  }

  onDashboardAtual() {
    this.props.history.push(URL.URLDashboardAtual);
  }

  render() {
    const menu = this.props.menu;
    return (
      <Navbar bg="dark" variant="dark" expand="lg">
        <Navbar.Brand href="#">Dashboard - VolpeLab</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto" bg="dark">
            <NavDropdown title="Menu" id="basic-nav-dropdown" size={38}>
              {menu && menu.length >= 0
                ? menu.map((elemento, i) => {
                    return (
                      <NavDropdown.Item
                        className="item-nav-dropdown"
                        key={i}
                        onClick={() => this.getMenuDashboard(elemento.link)}
                      >
                        {elemento.menu}
                      </NavDropdown.Item>
                    );
                  })
                : null}
            </NavDropdown>
          </Nav>
          <Form inline>
            <Button
              variant="outline-light"
              className="mr-sm-2"
              onClick={this.onLogout}
              style={{ padding: "10px", margin: "5px" }}
            >
              Sair
            </Button>
          </Form>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default NavBI;
